<template>
  <section>
    <author-name-and-position
      :name="fullName"
      :job-title="Job"
      :company="Company"
    />
    <author-logo :src="PhotoUrl" />
    <author-statistic
      :article-count="ArticleCount"
      :follower-count="FollowerCount"
      :is-follow-author-button-visible="isFollowAuthorButtonVisible"
      :author-id="Id"
      :is-followed="IsFollowed"
      @update:isFollowed="$emit('update:IsFollowed', $event)"
      @update:followerCount="$emit('update:FollowerCount', $event)"
    />
    <author-about :about="Bio" />
    <author-icons
      :facebook-url="FacebookUrl"
      :twitter-url="TwitterUrl"
      :linked-in-url="LinkedInUrl"
      :telegram-url="TelegramUrl"
    />
    <become-an-author-button />
  </section>
</template>

<script>
import mixins from '@/utils/mixins'
import AuthorLogo from '@/components/_sections/author/AuthorDetails/AuthorLogo/index.vue'
import AuthorNameAndPosition from '@/components/_sections/author/AuthorDetails/AuthorNameAndPosition/index.vue'
import AuthorAbout from '@/components/_sections/author/AuthorDetails/AuthorAbout/index.vue'
import AuthorStatistic from '@/components/_sections/author/AuthorDetails/AuthorStatistic/index.vue'
import BecomeAnAuthorButton from '@/components/_sections/author/AuthorDetails/BecomeAnAuthorButton/index.vue'
import AuthorIcons from '@/components/_sections/author/AuthorDetails/AuthorIcons/index.vue'

export default {
  name: 'AuthorDetailsMobile',
  mixins: [mixins.authorDetails],
  components: {
    AuthorLogo,
    AuthorNameAndPosition,
    AuthorAbout,
    AuthorStatistic,
    BecomeAnAuthorButton,
    AuthorIcons
  }
}
</script>

<style lang="scss" scoped></style>
